import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_PAYMENTS_REPORTS,
    fetchPaymentsReportSuccessful,
    startLoading,
    stopLoading
} from '../actions'



import {
    FETCH_PAYMENTS_LOADING_ID
} from '../store/loaders'



function * fetchPaymentsReport (payload){
    yield put(startLoading({id:FETCH_PAYMENTS_LOADING_ID}))
    try{
       const response=  yield call(DCore.get, `/payments/user/${payload.data}`)
        yield put(stopLoading({id:FETCH_PAYMENTS_LOADING_ID}))
        yield put (fetchPaymentsReportSuccessful(response.data))

    }catch(e){
        yield put(stopLoading({id:FETCH_PAYMENTS_LOADING_ID}))
        console.log("some thing went wrong", e)
    }
}



export function * fetchPaymentsReportSaga(){
    yield takeLatest(FETCH_PAYMENTS_REPORTS, fetchPaymentsReport)
}